import React, { memo, useEffect, useState } from "react";
import styles from "./index.modules.less";

const ComplaintCard = ({children}) => {
  

  return (
    <div className={styles.ComplaintCard}>
      {children}
    </div>
  );
};

export default memo(ComplaintCard);